// Central route map for your app
import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import App from "./App.js";

// Pages with lazy loading for better performance
const Home = lazy(() => import("./pages/Home.js"));
const SpringRepair = lazy(() => import("./pages/SpringRepair.js"));
const CableTrackRepair = lazy(() => import("./pages/CableTrackRepair.js"));
const RollerHingeBracketRepair = lazy(() => import("./pages/RollerHingeBracketRepair.js"));
const PanelDoorRepair = lazy(() => import("./pages/PanelDoorRepair.js"));
const OpenerServices = lazy(() => import("./pages/OpenerServices.js"));
const ControlAccess = lazy(() => import("./pages/ControlAccess.js"));
const SensorElectrical = lazy(() => import("./pages/SensorElectrical.js"));
const GarageDoorInstallation = lazy(() => import("./pages/GarageDoorInstallation.js"));
const EmergencySameDay = lazy(() => import("./pages/EmergencySameDay.js"));
const HowToChoose = lazy(() => import("./pages/howToChoose.js"));
const PriceCalculator = lazy(() => import("./pages/PriceCalculator.js"));

// Loading component for Suspense fallback
const PageLoading = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    fontSize: '16px',
    color: '#666'
  }}>
    Loading...
  </div>
);

export default function Routers() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="/" index element={<Home />} />
          <Route path="/spring-repair" element={<SpringRepair />} />
          <Route path="/cable-track" element={<CableTrackRepair />} />
          <Route path="/roller-hinge" element={<RollerHingeBracketRepair />} />
          <Route path="/panel-door" element={<PanelDoorRepair />} />
          <Route path="/opener-services" element={<OpenerServices />} />
          <Route path="/control-access" element={<ControlAccess />} />
          <Route path="/sensor-electrical" element={<SensorElectrical />} />
          <Route
            path="/garage-door-installation"
            element={<GarageDoorInstallation />}
          />
          <Route path="/emergency-repairs" element={<EmergencySameDay />} />
          <Route path="/how-to-choose" element={<HowToChoose />} />
          <Route path="/pricing2" element={<PriceCalculator />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
